import React, { Component } from "react";

export default class ContactUs extends Component {
  render() {
    return (
      <div class="container text-justify border mt-3 mb-5">
        <h1 class="text-center mb-5">Contact Us</h1>
        <p class="text-center">Contact us at info@meendutoons.com</p>
        <p class="text-center">
          Business Address : 13 Karani Bagh, High Court Colony, Ratanada,
          Jodhpur, Rajasthan - 342001
        </p>
      </div>
    );
  }
}
